// extracted by mini-css-extract-plugin
export var Absolute = "Popup-module--Absolute--4a346";
export var AwardsForm = "Popup-module--AwardsForm--60baf";
export var BodyLocked = "Popup-module--BodyLocked--d479f";
export var Button = "Popup-module--Button--00f4a";
export var ClickGuard = "Popup-module--ClickGuard--874f1";
export var CloseButton = "Popup-module--CloseButton--ea937";
export var Cols = "Popup-module--Cols--3652a";
export var Form = "Popup-module--Form--d7ee3";
export var Img = "Popup-module--Img--c3a86";
export var LargeText = "Popup-module--LargeText--ea47a";
export var Link = "Popup-module--Link--de358";
export var NormalText = "Popup-module--NormalText--45c2e";
export var SmallText = "Popup-module--SmallText--0eada";
export var Stretch = "Popup-module--Stretch--f6a3f";
export var TextContent = "Popup-module--TextContent--6caf0";
export var Touched = "Popup-module--Touched--30e03";
export var Typewriter = "Popup-module--Typewriter--ddab7";
export var Wrapper = "Popup-module--Wrapper--1e102";
export var hideMobile = "Popup-module--hideMobile--20a42";